import * as React from "react";

export const Desktop = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.40002 4.00003C1.40002 3.11637 2.11637 2.40002 3.00002 2.40002H13C13.8837 2.40002 14.6 3.11637 14.6 4.00002V11C14.6 11.8837 13.8837 12.6 13 12.6H9.87648L10.0947 13.4H12C12.3314 13.4 12.6 13.6687 12.6 14C12.6 14.3314 12.3314 14.6 12 14.6H4.00002C3.66865 14.6 3.40002 14.3314 3.40002 14C3.40002 13.6687 3.66865 13.4 4.00002 13.4H5.90538L6.12356 12.6H3.00003C2.11637 12.6 1.40002 11.8837 1.40002 11V4.00003ZM7.36739 12.6L7.14921 13.4H8.85084L8.63266 12.6H7.36739ZM3.00002 3.60002C2.77911 3.60002 2.60002 3.77911 2.60002 4.00003V8.81669H13.4V4.00002C13.4 3.77911 13.2209 3.60002 13 3.60002H3.00002ZM13.4 10.0167H2.60002V11C2.60002 11.2209 2.77911 11.4 3.00003 11.4H13C13.2209 11.4 13.4 11.2209 13.4 11V10.0167Z"
    />
);
